interface PillProps {
  variant: "green" | "orange" | "blue" | "gray";
  children: React.ReactNode;
}

export function Pill({ variant, children }: PillProps) {
  return <span className={`pill pill-${variant}`}>{children}</span>;
}
